<template>
    <div>

        <div class="sifarnik-top-line">
            <div class="sifarnik-top-left">
                <RouteTab current_tab="Predlošci" />
            </div>
            <div class="sifarnik-top-right">



                <div class="upload-stavke-button upload-dokumenta-button " @click="openPopNew()">
                    {{ $t("predlosci_page.templates.add_template_btn") }}
                    <div class="upload-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                            <g>
                                <g>
                                    <path fill="#fff"
                                        d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" />
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="open-folder-line-left switch-sudionici-wrapp right">
            <label class="bigger-switch">
                <input type="checkbox" v-model="is_editable_sort">
                <span class="slider round"></span>

            </label>
            <span class="status-switch">{{ edit_status }}</span>

        </div>
        <div class="sifarnik-main-wrapper">
            <div class="sifarnik-item-wrapper">
                <custom-spinner v-if="fetching" />
                <draggable v-else :sort="is_editable_sort" v-model="template_list">
                    <div class="sifarnik-item" v-for="(sifra, key) in template_list" :key="key" :id="'sifra-' + sifra.id">
                        <div class="sifarnik-item-left">
                            <div class="edit-menu">
                                <input type="checkbox" />
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <img :src="returnFileType(sifra.naziv)" />
                            <div class="sifarnik-item-no">{{ key + 1 }}</div>
                            <div class="sifarnik-item-title">{{ sifra.naziv }}</div>
                        </div>
                        <div class="sifarnik-item-right">

                            <div class="sifarnik-edit add-button add-pen"
                                @click="editSifra(('#sifra-' + sifra.id), sifra.id)"><svg xmlns="http://www.w3.org/2000/svg"
                                    width="13" height="13" viewBox="0 0 13 13">
                                    <g>
                                        <g>
                                            <path fill="#7b7b8a"
                                                d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <div @click="selectSifra(sifra.id)" class="sifarnik-edit sifarnik-view">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16"
                                    fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M6.61764 8.31605C6.61764 6.06224 8.44471 4.23516 10.6985 4.23516C12.9523 4.23516 14.7794 6.06224 14.7794 8.31605C14.7794 10.5699 12.9523 12.3969 10.6985 12.3969C8.44471 12.3969 6.61764 10.5699 6.61764 8.31605ZM10.6985 5.86752C9.34623 5.86752 8.24999 6.96376 8.24999 8.31605C8.24999 9.66833 9.34623 10.7646 10.6985 10.7646C12.0508 10.7646 13.147 9.66833 13.147 8.31605C13.147 6.96376 12.0508 5.86752 10.6985 5.86752Z"
                                        fill="#70707F" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2.3446 6.84296C1.8885 7.50018 1.72058 8.01428 1.72058 8.31605C1.72058 8.61782 1.8885 9.13191 2.3446 9.78913C2.78549 10.4244 3.44083 11.1131 4.26996 11.7495C5.93181 13.0249 8.21022 14.0293 10.6985 14.0293C13.1868 14.0293 15.4652 13.0249 17.1271 11.7495C17.9562 11.1131 18.6115 10.4244 19.0524 9.78913C19.5085 9.13191 19.6765 8.61782 19.6765 8.31605C19.6765 8.01428 19.5085 7.50018 19.0524 6.84296C18.6115 6.20765 17.9562 5.51898 17.1271 4.88263C15.4652 3.60717 13.1868 2.60281 10.6985 2.60281C8.21022 2.60281 5.93181 3.60717 4.26996 4.88263C3.44083 5.51898 2.78549 6.20765 2.3446 6.84296ZM3.27611 3.5877C5.15903 2.14257 7.77768 0.970459 10.6985 0.970459C13.6194 0.970459 16.238 2.14257 18.1209 3.5877C19.0642 4.31165 19.8432 5.1193 20.3935 5.91229C20.9286 6.68338 21.3088 7.52958 21.3088 8.31605C21.3088 9.10251 20.9286 9.94871 20.3935 10.7198C19.8432 11.5128 19.0642 12.3204 18.1209 13.0444C16.238 14.4895 13.6194 15.6616 10.6985 15.6616C7.77768 15.6616 5.15903 14.4895 3.27611 13.0444C2.33285 12.3204 1.55387 11.5128 1.00354 10.7198C0.468424 9.94871 0.0882263 9.10251 0.0882263 8.31605C0.0882263 7.52958 0.468424 6.68338 1.00354 5.91229C1.55387 5.1193 2.33285 4.31165 3.27611 3.5877Z"
                                        fill="#70707F" />
                                </svg>
                            </div>
                            <div class="sifarnik-delete" @click="popDeleteView(sifra.id)"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15">
                                    <g>
                                        <g>
                                            <path fill="#7b7b8a"
                                                d="M11.934 3.295v.918a.459.459 0 0 1-.459.46H.46A.459.459 0 0 1 0 4.212v-.918c0-.634.514-1.147 1.148-1.147h2.524v-.46c0-.76.617-1.376 1.377-1.376h1.836c.76 0 1.377.616 1.377 1.377v.459h2.525c.633 0 1.147.513 1.147 1.147zM4.59 2.148h2.754v-.46a.46.46 0 0 0-.459-.458H5.05a.46.46 0 0 0-.459.459zm6.473 3.442c.082 0 .147.069.144.15l-.38 7.948A1.375 1.375 0 0 1 9.453 15h-6.97c-.736 0-1.34-.576-1.375-1.312l-.38-7.947a.143.143 0 0 1 .144-.15zm-3.26 7.115a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0z" />
                                        </g>
                                    </g>
                                </svg></div>
                        </div>
                    </div>
                </draggable>
            </div>
            <div class="spisi-right">
                <div class="detalji-spisa section detalji-radni-popratna" v-if="selected_file != null">
                    <div class="section-title">
                        <span>{{ $t('page_2.page_2_4.detail_2.title') }}</span>
                    </div>
                    <a class="entry-exit" @click="selected_file = null"><img src="@/assets/img/entry_form_close.svg" /></a>
                    <div class="detalji-spisa-top">
                        <img class="doc-icon" :src="docx_img" />
                        <div class="inside-folder-txts">
                            <div class="inside-folder-title">{{ selected_file.naziv }}</div>
                        </div>
                    </div>
                    <div class="detalji-spisa-list">
                        <div class="detalji-spisa-middle">
                            <div class="case-info-item">
                                <div class="case-info-item-title">{{ $t("predlosci_page.templates.created") }}</div>
                                <div class="case-info-item-info">
                                    {{ condensedUser(selected_file.odvjetnik_odvjetnikTotemplate_docs_created_by) }}
                                    {{ switchDate(selected_file.created_at) }}
                                </div>
                            </div>
                            <!-- <div class="case-info-item">
                            <div class="case-info-item-title">{{ $t('page_2.page_2_4.detail_2.tl_2') }}:</div>
                            <div class="case-info-item-info">
                                <a href="#">{{ selected_file.createdBy.user.displayName }}</a>
                            </div>
                        </div> -->
                            <div class="case-info-item">
                                <div class="case-info-item-title">{{ $t("predlosci_page.templates.edited") }}</div>
                                <div class="case-info-item-info">
                                    <a href="#">
                                        {{ condensedUser(selected_file.odvjetnik_odvjetnikTotemplate_docs_updated_by) }}
                                        ({{
                                            switchDate(selected_file.updated_at)
                                        }})</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="detalji-buttons detalji-buttons-tri">
                        <div class="radni-button icon-button" @click="downloadDoc()">
                            {{ $t('page_2.page_2_4.detail_2.btn_2') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M6.61764 8.31605C6.61764 6.06224 8.44471 4.23516 10.6985 4.23516C12.9523 4.23516 14.7794 6.06224 14.7794 8.31605C14.7794 10.5699 12.9523 12.3969 10.6985 12.3969C8.44471 12.3969 6.61764 10.5699 6.61764 8.31605ZM10.6985 5.86752C9.34623 5.86752 8.24999 6.96376 8.24999 8.31605C8.24999 9.66833 9.34623 10.7646 10.6985 10.7646C12.0508 10.7646 13.147 9.66833 13.147 8.31605C13.147 6.96376 12.0508 5.86752 10.6985 5.86752Z"
                                    fill="#70707F" />
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M2.3446 6.84296C1.8885 7.50018 1.72058 8.01428 1.72058 8.31605C1.72058 8.61782 1.8885 9.13191 2.3446 9.78913C2.78549 10.4244 3.44083 11.1131 4.26996 11.7495C5.93181 13.0249 8.21022 14.0293 10.6985 14.0293C13.1868 14.0293 15.4652 13.0249 17.1271 11.7495C17.9562 11.1131 18.6115 10.4244 19.0524 9.78913C19.5085 9.13191 19.6765 8.61782 19.6765 8.31605C19.6765 8.01428 19.5085 7.50018 19.0524 6.84296C18.6115 6.20765 17.9562 5.51898 17.1271 4.88263C15.4652 3.60717 13.1868 2.60281 10.6985 2.60281C8.21022 2.60281 5.93181 3.60717 4.26996 4.88263C3.44083 5.51898 2.78549 6.20765 2.3446 6.84296ZM3.27611 3.5877C5.15903 2.14257 7.77768 0.970459 10.6985 0.970459C13.6194 0.970459 16.238 2.14257 18.1209 3.5877C19.0642 4.31165 19.8432 5.1193 20.3935 5.91229C20.9286 6.68338 21.3088 7.52958 21.3088 8.31605C21.3088 9.10251 20.9286 9.94871 20.3935 10.7198C19.8432 11.5128 19.0642 12.3204 18.1209 13.0444C16.238 14.4895 13.6194 15.6616 10.6985 15.6616C7.77768 15.6616 5.15903 14.4895 3.27611 13.0444C2.33285 12.3204 1.55387 11.5128 1.00354 10.7198C0.468424 9.94871 0.0882263 9.10251 0.0882263 8.31605C0.0882263 7.52958 0.468424 6.68338 1.00354 5.91229C1.55387 5.1193 2.33285 4.31165 3.27611 3.5877Z"
                                    fill="#70707F" />
                            </svg>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <v-dialog v-model="editTemplatePop" width="564px">
            <v-card color="universal-vcard">
                <div class="universal-vdialog-title">
                    {{ pop_text }}
                </div>


                <div class="form-input-wrapper ">
                    <div :class="['loading-spinner', is_hovering ? 'active' : '']"></div>
                    <div :class="['file-list-wrapper', 'project-attachments', is_hovering ? 'active' : '']"
                        @dragover.prevent="is_hovering = true" @dragleave.prevent="is_hovering = false"
                        @drop.prevent="drop">
                        <label :class="['form-input', 'attachments-wrapper', is_hovering ? 'active' : '']">
                            <div class="items-holder">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    xmlns:avocode="https://avocode.com/" id="SVGDoc" width="14" height="21" version="1.1"
                                    viewBox="0 0 14 21">
                                    <defs />
                                    <desc>Generated with Avocode.</desc>
                                    <g>
                                        <g>
                                            <title>Shape 3</title>
                                            <path
                                                d="M6.70195,21.0001c-3.69596,0 -6.70195,-2.81801 -6.70195,-6.283v-8.79622c0,-0.46329 0.40042,-0.83771 0.89347,-0.83771c0.49341,0 0.89371,0.37441 0.89371,0.83771v8.79622c0,2.54002 2.20454,4.60749 4.91476,4.60749c2.71022,0 4.91464,-2.06747 4.91464,-4.60749v-9.21516c0,-1.61676 -1.40285,-2.93198 -3.12746,-2.93198c-1.72472,0 -3.12757,1.31521 -3.12757,2.93198v8.37765c0,0.69265 0.60129,1.25637 1.34039,1.25637c0.73898,0 1.34027,-0.56372 1.34027,-1.25637v-7.9587c0,-0.46329 0.40054,-0.83771 0.89359,-0.83771c0.49329,0 0.89371,0.37441 0.89371,0.83771v7.9587c0,1.61676 -1.40309,2.93188 -3.12757,2.93188c-1.7246,0 -3.12757,-1.31512 -3.12757,-2.93188v-8.37765c0,-2.53992 2.20442,-4.60749 4.91476,-4.60749c2.71022,0 4.91464,2.06757 4.91464,4.60749v9.21516c0,3.46498 -3.00598,6.283 -6.70183,6.283z"
                                                fill="#3326ae" fill-opacity="1" />
                                        </g>
                                    </g>
                                </svg>
                                <span v-if="upload_file != null">{{ upload_file.name }}</span>
                                <span v-else>{{ $t('predlosci_page.templates.template_popups.choose_attach') }}</span>
                            </div>

                            <input @change="onChange" type="file" id="assetsFieldHandle" ref="file" style="display:none;"
                                accept=".docx,.xlsx" />
                        </label>
                    </div>
                </div>
                <v-text-field class="universal-vdialog-textfield"
                    :label="$t('predlosci_page.templates.template_popups.final_doc_name')" v-model="doc_name">
                </v-text-field>

                <div class="vdialog-buttons-wrapper">
                    <div class="universal-vdialog-button vbutton-secondary" @click="editTemplatePop = false"> {{
                        $t("repetitive.cancel") }}
                    </div>
                    <div class="universal-vdialog-button vbutton-primary" @click="editAdd()"> {{ save_btn_txt }}
                    </div>
                </div>
                <v-snackbar v-model="snackbar_pop" color="snack-custom-dark-blue" elevation="24">
                    {{ pop_error_msg }}
                    <template v-slot:action="{ attrs }">
                        <v-btn color="white" text v-bind="attrs" @click="snackbar_pop = false">
                            {{ $t("repetitive.okay") }}
                        </v-btn>
                    </template>
                </v-snackbar>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteTemplatePop" width="564px">
            <v-card color="universal-vcard">
                <div class="universal-vdialog-title" v-if="selected_file != null">
                    {{ $t("predlosci_page.templates.template_popups.delete_title") }} <br /> {{ selected_file.naziv }}
                </div>
                <div class="vdialog-buttons-wrapper">
                    <div class="universal-vdialog-button vbutton-secondary" @click="deleteTemplatePop = false">{{
                        $t("repetitive.cancel") }}
                    </div>
                    <div class="universal-vdialog-button vbutton-error" @click="deleteCode()">
                        {{ $t("predlosci_page.templates.template_popups.potvrdi") }}
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import sharepoint from "@/apiCallers/promise_handler_db/sharepoint";
import RouteTab from "@/components/costSheetComponents/sifarnik/RouteTab.vue";
import gsap from "gsap";
import $ from "jquery";
import moment from "moment";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";



import draggable from "vuedraggable";

import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import CustomSpinner from "@/components/generalComponents/CustomSpinner.vue";

export default {
    components: {
        CustomDropdown,
        RouteTab,
        draggable,
        CustomSpinner
    },

    data() {

        return {
            doc_name: "",
            upload_file: null,
            is_edit_mode: false,
            is_hovering: false,
            is_editing: false,

            filelist: [],
            deleteTemplatePop: false,
            selected_file: null,


            is_editable_sort: false,
            template_list: [],
            expanded_templates: [],
            docx_img: require("@/assets/img/doc_icon.svg"),


            selected_sifra: null,
            editTemplatePop: false,

            // popup edit create values
            create_edit_sifra: "",
            pop_text: this.$t("predlosci_page.templates.template_popups.pop_text"),
            edit_pop_text: this.$t("predlosci_page.templates.template_popups.edit_pop_text"),
            new_pop_text: this.$t("predlosci_page.templates.template_popups.new_pop_text"),
            pop_error_msg: this.$t("predlosci_page.templates.template_popups.pop_error_msg1"),
            snackbar_pop: false,
            save_btn_txt: this.$t("predlosci_page.templates.template_popups.save_btn_txt"),
            fetching: true,
        };

    },
    watch: {
        upload_file: function () {
            if (this.upload_file != null && this.doc_name != null) {
                this.doc_name = this.upload_file.name.replace(".docx", "").replace(".xlsx", "");
            }
        },
        is_editable_sort() {
            if (this.is_editable_sort) {
                gsap.to(".edit-menu", 0.5, { paddingRight: "20px", display: "block", opacity: 1 });
                gsap.to(".sifarnik-edit-hidden", 0.5, { paddingRight: "20px", display: "flex", opacity: 1 });
                // gsap.to(".not-editable-sudionici", 0.5, {  opacity: 0.3 });

            }
            else {
                gsap.to(".edit-menu", 0.2, { paddingRight: "0px", opacity: 0, display: "none" });
                gsap.to(".sifarnik-edit-hidden", 0.2, { paddingRight: "0px", opacity: 0, display: "none" });
                // gsap.to(".not-editable-sudionici", 0.5, {  opacity: 1 });
            }
        },
        template_list: function () {
            console.log("change in order")
            if (this.is_editable_sort) {
                predmet_hand.updateOrderSifre(this.template_list, 5);
                this.selected_file = null;
                $(".sifarnik-item").removeClass("opened-sifarnik");
            }
        },
        // sifra_type: function () {
        //     $(".sifarnik-item").removeClass("opened-sifarnik");
        //     // this.getData();
        // },
        editTemplatePop: function () {
            if (!this.editTemplatePop) {
                $(".sifarnik-item").removeClass("opened-sifarnik");

            }
        }
    },
    computed: {
        edit_status: function () {
            return this.is_editable_sort ? this.$t("predlosci_page.templates.redoslijed_edit") : this.$t("predlosci_page.templates.redoslijed_view");
        }
    },
    methods: {
        condensedUser: function (user) {
            if (user == undefined || user == null) {
                return ""
            } else
                return user.ime + " " + user.prezime
        },
        verifyDocName: function () {
            if (this.doc_name.trim().length === 0) {
                this.pop_error_msg = this.$t('predlosci_page.templates.template_popups.pop_error_msg2');
                return false;
            } else if (this.template_list.filter((p) => { return p.naziv == (this.doc_name + ".docx") }).length > 0) {
                this.pop_error_msg = this.$t('predlosci_page.templates.template_popups.pop_error_msg3');
                return false;
            }
            else
                return true;
        },
        downloadDoc: async function () {
            var tmp_arr = this.selected_file.naziv.split(".")
            var tmp_extension = tmp_arr.pop();
            await sharepoint.downloadTemplateDoc(tmp_arr.join("."), tmp_extension).then((resp) => {
                // console.log(resp.data);
                var newBlob = new Blob([resp.data], {
                    type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                });
                var data = window.URL.createObjectURL(newBlob);

                var link = document.createElement("a");
                link.href = data;
                link.download = this.selected_file.naziv;
                link.click();
                setTimeout(function () {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    window.URL.revokeObjectURL(data);
                }, 100);

            })
        },
        switchDate(inData) {
            return moment(inData.toString()).format("lll");
        },
        drop(event) {
            event.preventDefault();
            let tmp_files = event.dataTransfer.files;
            // tmp_files = tmp_files.filter((p) => p.name.toString().endsWith(".docx"));
            this.$refs.file.files = tmp_files;
            this.is_hovering = false;
            this.onChange(); // Trigger the onChange event manually
        },
        deleteAttach() {
            this.upload_file = null;
        },
        onChange() {
            const add_files = [...this.$refs.file.files];
            const final_files = add_files.filter((file) => file.name.toString().endsWith(".docx") || file.name.toString().endsWith(".xlsx"));
            if (final_files.length > 0) {
                this.upload_file = final_files[0]
            }

        },
        deleteCode: async function () {
            await sharepoint.deleteTemplateDoc(this.selected_file.uid).then((resp) => {
                this.deleteTemplatePop = false;
                this.selected_file = null;
                this.template_list = resp.data.order;
                this.expanded_templates = resp.data.template_docs
            })
        },
        popDeleteView: function (id) {
            this.selectSifra(id)
            // this.selected_file = tmp_doc;
            this.deleteTemplatePop = true;
        },

        editAdd: function () {
            if (this.is_edit_mode) {
                this.updateCode();
            } else {
                this.addCode();
            }
        },
        selectSifra: function (sel_file) {
            $(".sifarnik-item").removeClass("opened-sifarnik");
            $("#sifra-" + sel_file).addClass("opened-sifarnik");
            this.selected_file = this.expanded_templates.find(element => element.uid == sel_file);
        },
        returnFileType(file_name) {
            var idx_ext = file_name.split(".").length - 1;
            var extension = file_name.split(".")[idx_ext].toLowerCase();
            var return_val = require("@/assets/img/doc_icon.svg");
            switch (extension) {
                case "docx":
                    return_val = require("@/assets/img/doc_icon.svg");
                    break;
                case "doc":
                    return_val = require("@/assets/img/doc_icon.svg");
                    break;
                case "pdf":
                    return_val = require("@/assets/img/pdf_icon.svg");
                    break;
                case "csv":
                    return_val = require("@/assets/img/xls_icon.svg");
                    break;
                case "xls":
                    return_val = require("@/assets/img/xls_icon.svg");
                    break;
                case "xlsx":
                    return_val = require("@/assets/img/xls_icon.svg");
                    break;

                default:
                    return_val = require("@/assets/img/doc_icon.svg");
                    break;
            }
            return return_val;
        },

        editSifra: function (active_id, sel_file) {
            this.selected_file = this.expanded_templates.find(element => element.uid == sel_file);
            this.save_btn_txt = this.$t("predlosci_page.templates.template_popups.save_btn_txt");
            // opened-sifarnik
            this.pop_text = this.edit_pop_text + " " + this.selected_file.naziv;
            this.editTemplatePop = true;
            $(".sifarnik-item").removeClass("opened-sifarnik");
            $(active_id).addClass("opened-sifarnik");
            this.selected_file = this.expanded_templates.find(element => element.uid == sel_file);
            console.log(this.selected_file.naziv)
            this.doc_name = this.selected_file.naziv.replace(".docx", "").replace(".xlsx", "");
            this.is_edit_mode = true;
        },
        openPopNew: function () {
            this.save_btn_txt = this.$t("predlosci_page.templates.template_popups.add")
            this.doc_name = ""
            this.pop_text = this.new_pop_text;
            $(".sifarnik-item").removeClass("opened-sifarnik");
            this.selected_sifra = null;
            this.create_edit_sifra = "";
            this.editTemplatePop = true;
            this.is_edit_mode = false;
        },

        // UPDATE DATA START
        validateUpdate: function () {
            // If no new file has been added
            let no_ext_name = this.selected_file.naziv.replace(".docx", "").replace(".xlsx", "");
            if (this.upload_file == null) {
                if (no_ext_name == this.doc_name) {
                    // Nothing has changed
                    this.pop_error_msg = this.$t('predlosci_page.templates.template_popups.pop_error_msg4')
                    return false;
                }
                else if (this.doc_name.trim().length === 0) {
                    this.pop_error_msg = this.$t('predlosci_page.templates.template_popups.pop_error_msg2')
                    return false;
                } else if (this.template_list.filter((p) => { return p.naziv == (this.doc_name + ".docx") || p.naziv == (this.doc_name + ".xlsx") }).length > 0) {
                    this.pop_error_msg = this.$t('predlosci_page.templates.template_popups.pop_error_msg3')
                    return false;
                } else {
                    return true;
                }
            } else {
                if (this.doc_name.trim().length === 0) {
                    this.pop_error_msg = this.$t('predlosci_page.templates.template_popups.pop_error_msg2')
                    return false;
                } else if (this.template_list.filter((p) => { return p.naziv == (this.doc_name + ".docx") || p.naziv == (this.doc_name + ".xlsx") }).length > 0 && no_ext_name != this.doc_name) {
                    this.pop_error_msg = this.$t('predlosci_page.templates.template_popups.pop_error_msg3')
                    return false;
                } else {
                    return true;
                }
            }
        },

        updateCode: async function () {
            // console.log(this.upload_file, this.doc_name, this.$store.state.logged_in_user.uid)
            if (this.validateUpdate()) {
                const formData = new FormData();
                formData.append("files", this.upload_file);
                formData.append("docname", this.doc_name);
                formData.append("user", this.$store.state.logged_in_user.uid);

                console.log(formData)
                await sharepoint.updateTemplateDoc(formData, this.selected_file.uid).then((resp) => {
                    this.template_list = resp.data.order;
                    this.expanded_templates = resp.data.template_docs
                    this.editTemplatePop = false;
                    this.doc_name = "";
                    this.upload_file = null;
                    this.selected_file = null;
                });
            } else {
                this.snackbar_pop = true;
                setTimeout(() => {
                    this.snackbar_pop = false
                }, 3000)
            }


        },
        // UPDATE DATA END



        // ADD NEW DATA START

        addCode: async function () {
            if (this.upload_file == null) {
                this.pop_error_msg = this.$t('predlosci_page.templates.template_popups.pop_error_msg5')
                this.snackbar_pop = true;
                setTimeout(() => {
                    this.snackbar_pop = false
                }, 3000)
            } else {
                if (this.verifyDocName()) {
                    // console.log(this.upload_file, this.doc_name, this.$store.state.logged_in_user.uid)
                    const formData = new FormData();
                    formData.append("files", this.upload_file);
                    formData.append("docname", this.doc_name);
                    formData.append("user", this.$store.state.logged_in_user.uid);

                    console.log(formData)
                    await sharepoint.uploadTemplateDoc(formData).then((resp) => {
                        this.template_list = resp.data.order;
                        this.expanded_templates = resp.data.template_docs
                        this.editTemplatePop = false;
                        this.doc_name = "";
                        this.upload_file = null;
                        this.selected_file = null;
                    });
                } else {
                    this.snackbar_pop = true;
                    setTimeout(() => {
                        this.snackbar_pop = false
                    }, 3000)
                }
            }
        },
        // ADD NEW DATA END
    },
    async created() {
        await sharepoint.getTemplateDocs().then((resp) => {
            this.template_list = resp.data.order;
            this.expanded_templates = resp.data.template_docs
        })
            .finally(() => {
                this.fetching = false;
            });

    },

    mounted() {
        // this.getData()

        this.$store.state.paginacija.title = this.$t("breadcrumbs.templates");

    }

}

</script>

<style></style>